import { createFileRoute, notFound } from "@tanstack/react-router";

import { deploymentsQueries } from "@/api/resources/deployments/queries";
import { usersQueries } from "@/api/resources/users/queries";
import { workspacesQueries } from "@/api/resources/workspaces/queries";
import UserPageDeployment from "@/components/User/UserPageDeployment";
import i18n from "@/providers/i18n";
import { userName } from "@/utils/format";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/deployments/$deployment_id/users/$user_id/")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.deployments"),
        icon: <Icon.DEPLOYMENTS />,
        path: "/workspaces/$workspace_id/deployments",
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id, deployment_id, user_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
    const currentDeployment = await context.queryClient.ensureQueryData(deploymentsQueries.byId(deployment_id));
    if (!currentDeployment) throw notFound();
    const currentUser = await context.queryClient.ensureQueryData(usersQueries.byId(user_id));
    if (!currentUser) throw notFound();

    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: currentDeployment.name,
        icon: <Icon.DEPLOYMENT />,
        path: "/workspaces/$workspace_id/deployments/$deployment_id",
      },
      {
        label: i18n.t("navigation.deployments-users"),
        icon: <Icon.USERS />,
        path: "/workspaces/$workspace_id/deployments/$deployment_id/users",
      },
      {
        label: userName(currentUser) ?? "",
        icon: <Icon.USER />,
      },
    ];
    context.breadcrumbs.splice(2, 3, ...breadcrumbs);
  },
  component: UserPageDeployment,
});
